export const SET_TOKEN = 'Auth//SET_TOKEN'
export const SET_USER = 'Auth//SET_USER'



// WEBPACK FOOTER //
// ./src/app/auth/vuex/mutations-types.js